<div class="sidenav">
  <div class="brand">
    <div class="brand-icon">
      <mat-icon fontIcon="luggage"></mat-icon>
    </div>
    <div class="brand-name">Tourist</div>
    <div class="brand-tagline">Simplify Your Tourist Tax</div>
  </div>

  <mat-nav-list class="nav-list" aria-label="Primary navigation">
    @for(module of visibleModules; track module.id){
      @if(isExpandableModule(module)){
        <button mat-button class="nav-item"
          (click)="toggleMenu(module.name)"
          [class.expanded]="activeMenu === module.name"
          [class.active-trail]="isGroupActive(module)"
          [attr.aria-expanded]="activeMenu === module.name"
          [attr.aria-controls]="'submenu-' + module.id">
          <mat-icon class="nav-icon">{{module.icon}}</mat-icon>
          <span class="nav-label">{{module.name}}</span>
          <mat-icon class="expand-icon">
            {{ activeMenu === module.name ? 'expand_less' : 'expand_more' }}
          </mat-icon>
        </button>
        @if(activeMenu === module.name){
          <div class="submenu" [id]="'submenu-' + module.id" role="group" [attr.aria-label]="module.name">
            @for(option of getSortedOptions(module); track $index){
              @if(getOptionRoute(module, option)){
                <!-- exact only where one sibling's route is a prefix of another's, so both
                     would otherwise light up at once. -->
                <button class="submenu-item" routerLinkActive="active-sub" mat-button
                  [routerLinkActiveOptions]="{ exact: !!option.exactMatch }"
                  [routerLink]="'/app/' + getOptionRoute(module, option)">
                  <span class="submenu-dot"></span>
                  <span class="nav-label">{{option.name}}</span>
                </button>
              } @else {
                <button class="submenu-item" mat-button>
                  <span class="submenu-dot"></span>
                  <span class="nav-label">{{option.name}}</span>
                </button>
              }
            }
          </div>
        }
      } @else {
        <!-- exact only where one item's route is a prefix of another's (Take a Payment sits at
             /app/cashering, Cash Drawers at /app/cashering/admin-drawers) so both would
             otherwise light up at once. -->
        <button mat-button class="nav-item"
          [routerLink]="'/app/' + getRouteForModule(module.routeName, module.name)"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: !!module.exactMatch }">
          <mat-icon class="nav-icon">{{module.icon}}</mat-icon>
          <span class="nav-label">{{labelFor(module)}}</span>
        </button>
      }
    }
  </mat-nav-list>
</div>
